__webpack_require__.p = "/procurement_system_MIS/";